// Formats to "SPEAKER MM:SS.ss MM:SS.ss words..."
export const formatTimestamp = (seconds) => {
    if (seconds === undefined || seconds === null || isNaN(seconds)) return '00:00.00'
    const totalSeconds = Math.max(0, seconds)
    const mins = Math.floor(totalSeconds / 60)
    const secs = (totalSeconds % 60).toFixed(2)
    return `${mins.toString().padStart(2, '0')}:${secs.padStart(5, '0')}`
}


// format (XML/STM/SRT/TextGrid) speechSubSegment start/end times in ms
const getTranscriptTextFromArray = (transcriptData) => {
    let text = ''
    const sortedSegments = [...transcriptData].sort((a, b) => (a.startTime || 0) - (b.startTime || 0))
    sortedSegments.forEach(seg => {
        if (seg.speechSubSegments) {
            seg.speechSubSegments.forEach(sss => {
                if (sss.words && sss.words.length > 0) {
                    const speakerId = seg.speakerId || 'Unknown'
                    const startTime = formatTimestamp((sss.startTime || 0) / 1000)
                    const endTime = formatTimestamp((sss.endTime ?? sss.startTime ?? 0) / 1000)
                    const words = sss.words.join(' ')
                    text += `${speakerId} ${startTime} ${endTime} ${words}\n`
                }
            })
        }
    })
    return text.trim()
}

const getTranscriptTextFromXML = (transcriptData) => {
    if (!transcriptData?.AudioDoc?.SegmentList) return ''
    let text = ''
    for (const sl of transcriptData.AudioDoc.SegmentList) {
        for (const ss of sl.SpeechSegment) {
            const speakerId = ss.$.spkrid || ss.$.speaker || 'Unknown'
            const startTime = parseFloat(ss.$.stime) || 0
            const words = ss.Word || []
            // segment end = start time of the last word + that word's duration
            let lastWordEndTime = startTime
            if (words.length > 0) {
                const lastWord = words[words.length - 1]
                lastWordEndTime = parseFloat(lastWord.$.stime) + parseFloat(lastWord.$.dur)
            }
            const wordText = words.map(w => w._).join(' ')
            text += `${speakerId} ${formatTimestamp(startTime)} ${formatTimestamp(lastWordEndTime)} ${wordText}\n`
        }
    }
    return text.trim()
}

// Raw per-segment arrays (e.g. parsed STM/SRT/TextGrid)
const getTranscriptTextFromSimple = (transcriptData) => {
    let text = ''
    const sortedSegments = [...transcriptData].sort((a, b) => (a.startTime || 0) - (b.startTime || 0))
    sortedSegments.forEach(seg => {
        const speakerId = seg.speakerId || seg.speaker || 'Unknown'
        const startTime = seg.startTime || 0
        const endTime = seg.endTime ?? (startTime + (seg.duration || 0))
        text += `${speakerId} ${formatTimestamp(startTime)} ${formatTimestamp(endTime)} ${seg.text}\n`
    })
    return text.trim()
}

export const getTranscriptText = (transcriptData, transcriptXMLPath = '') => {
    if (!transcriptData) return ''
    try {
        if (Array.isArray(transcriptData) && transcriptData[0]?.startTime !== undefined) {
            return getTranscriptTextFromArray(transcriptData)
        } else if (transcriptXMLPath.endsWith('.xml')) {
            return getTranscriptTextFromXML(transcriptData)
        } else if (
            transcriptXMLPath.endsWith('.stm') ||
            transcriptXMLPath.endsWith('.TextGrid') ||
            transcriptXMLPath.endsWith('.srt')
        ) {
            return getTranscriptTextFromSimple(transcriptData)
        }
    } catch (e) {
        console.error('Error parsing transcript:', e)
    }
    return ''
}
